export const PROFILE_READONLY = [
  ["Email", "Email (login)"],
  ["Phone", "Phone"],
];

export const PROFILE_EDITABLE = [
  ["First_Name", "First name"],
  ["Middle_Name", "Middle name"],
  ["Last_Name", "Last name"],
  ["Alt_Phone", "Alternate phone"],
];

export function displayProfileValue(value) {
  if (value == null || String(value).trim() === "") return "—";
  return String(value);
}
